import React from 'react';
import {motion} from 'framer-motion';
import {useNavigate} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {useSubscription} from '../contexts/SubscriptionContext';

const {FiLock, FiZap} = FiIcons;

function FeatureGate({children, feature = 'this feature'}) {
  const navigate = useNavigate();
  const {canAccessPremiumFeatures, isTrialExpired} = useSubscription();

  if (!canAccessPremiumFeatures()) {
    return (
      <div className="relative">
        {/* Blurred/Greyed out content */}
        <div className="pointer-events-none select-none opacity-30 blur-sm">
          {children}
        </div>

        {/* Overlay */}
        <div className="absolute inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm">
          <motion.div
            initial={{opacity: 0, scale: 0.9}}
            animate={{opacity: 1, scale: 1}}
            className="bg-white rounded-xl shadow-xl p-8 max-w-md mx-4 text-center border-2 border-yellow-400"
          >
            <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <SafeIcon icon={FiLock} className="w-8 h-8 text-yellow-600" />
            </div>
            
            <h3 className="text-2xl font-space-grotesk font-bold text-secondary mb-2">
              {isTrialExpired() ? 'Trial Expired' : 'Premium Feature'}
            </h3>
            
            <p className="text-gray-600 mb-6">
              {isTrialExpired()
                ? 'Your 14-day free trial has ended. Upgrade to Pro to continue using all features.'
                : `Upgrade to Pro to access ${feature} and unlock your full potential.`}
            </p>

            <div className="bg-blue-50 rounded-lg p-4 mb-6">
              <h4 className="font-semibold text-gray-800 mb-2">Pro Features Include:</h4>
              <ul className="text-sm text-gray-700 space-y-1 text-left">
                <li>✓ Unlimited college tracking</li>
                <li>✓ Full timeline & deadlines</li>
                <li>✓ Guardian access</li>
                <li>✓ Public resume</li>
                <li>✓ Video highlights</li>
                <li>✓ Priority support</li>
              </ul>
            </div>

            <button
              onClick={() => navigate('/settings?tab=subscription')}
              className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-3 rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all font-semibold flex items-center justify-center space-x-2"
            >
              <SafeIcon icon={FiZap} className="w-5 h-5" />
              <span>Upgrade to Pro</span>
            </button>

            <p className="text-xs text-gray-500 mt-4">
              Starting at $12/month or $99/year
            </p>
          </motion.div>
        </div>
      </div>
    );
  }

  return children;
}

export default FeatureGate;